// Upload adapter that routes CKEditor 5 image uploads to the Rails
// `/blog/images` endpoint. Register it on an editor instance by passing
// `railsUploadAdapterPlugin` in the `extraPlugins` config.

const UPLOAD_PATH = '/blog/images';

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

class RailsUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          const data = new FormData();
          data.append('file', file);

          const xhr = new XMLHttpRequest();
          xhr.open('POST', UPLOAD_PATH, true);
          xhr.responseType = 'json';
          xhr.setRequestHeader('X-CSRF-Token', csrfToken());
          xhr.setRequestHeader('Accept', 'application/json');

          xhr.upload.addEventListener('progress', (event) => {
            if (event.lengthComputable) {
              this.loader.uploadTotal = event.total;
              this.loader.uploaded = event.loaded;
            }
          });

          // CKEditor's FileRepository contract expects the upload promise to
          // reject with a human-readable message string, which it surfaces to
          // the user as a notification — hence the disable below.
          /* eslint-disable prefer-promise-reject-errors */
          xhr.addEventListener('error', () => reject('Image upload failed.'));
          xhr.addEventListener('abort', () => reject());
          xhr.addEventListener('load', () => {
            const { response } = xhr;
            if (!response || xhr.status >= 400) {
              reject(response?.error?.message || 'Image upload failed.');
              return;
            }
            resolve({ default: response.url });
          });
          /* eslint-enable prefer-promise-reject-errors */

          xhr.send(data);
        })
    );
  }

  abort() {}
}

export default function railsUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => new RailsUploadAdapter(loader);
}
